import axios from 'axios';

const API_BASE_URL = 'https://api-blocksafubsc.blocksafu.com/api';

export const stakingApi = {
  getStakingInfo: async (contractAddress) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/staking/info`, {
        params: {
          contract: contractAddress
        },
        timeout: 10000 // 10 second timeout
      });
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('API returned unsuccessful response');
      }
    } catch (error) {
      console.error('Error fetching staking info:', error);
      
      // Return fallback values if API fails
      return {
        apr: "0.00",
        apy: "0.00",
        actualAPR: "0.00",
        actualAPY: "0.00",
        totalShares: "0",
        totalDividends: "0.0",
        dividendsPerShare: "0.0",
        contractBalance: "0.0",
        lastResetAPR: new Date().toISOString(),
        daysSinceReset: 0,
        totalDistributed: "0.0"
      };
    }
  }
};